import { SearchObject } from "app/common/Model/SearchObject";
import { exportExcelRevenueAllocationReport } from "app/services/InvoiceItemService";
import { reportRevenueAllocation } from "app/services/ReportService";
import { makeAutoObservable } from "mobx";
import { toast } from "react-toastify";
export default class ReportRevenueAllocationStore {
  listDataRevenueAllocation = null;
  searchReportRevenueAllocation = {
    ...new SearchObject(),
    fromDate: new Date(),
    toDate: new Date(),
    departmentId: null,
    staffId: null,
  }
  constructor() {
    makeAutoObservable(this);
  }

  handleChangeFormSearchRevenueAllocation = (searchReportRevenueAllocation) => {
    this.searchReportRevenueAllocation = {
      ...this.searchReportRevenueAllocation,
      ...searchReportRevenueAllocation,
    };
      this.pagingReportRevenueAllocation();
  }

  pagingReportRevenueAllocation = async () => {
    let { departmentId, staffId, positionId, serviceId, groupserviceId, drugId, groupdrugId, treamentId, ...ortherData } = this.searchReportRevenueAllocation;
    if (staffId) {
      ortherData.staffId = staffId?.id;
    }
    if (departmentId) {
      ortherData.departmentId = departmentId?.id;
    }
    if (positionId) {
      ortherData.positionId = positionId?.id;
    }
    if (serviceId) {
      ortherData.serviceId = serviceId?.id;
    }
    if (drugId) {
      ortherData.drugId = drugId?.id;
    }
    if (Array.isArray(groupdrugId)) {
      ortherData.groupdrugId = groupdrugId.map(item => item?.id);
    }
    if (Array.isArray(groupserviceId)) {
      ortherData.groupserviceId = groupserviceId.map(item => item?.id);
    }
    if (treamentId) {
      ortherData.treamentId = treamentId?.id;
    }
    return await reportRevenueAllocation({ ...ortherData })
      .then(({ data }) => {
        this.listDataRevenueAllocation = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu thẻ trả trước có lỗi");
      });
  };

  handleExportExcelRevenueAllocationReport = async (searchObj) => {
    const search = this.normalizeSearchReportVoucher(searchObj);
    try {
      const response = await exportExcelRevenueAllocationReport(search);
      if (response.status === 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "BC_PHAN_BO_DOANH_SO_THEO_NHAN_VIEN.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      }
    } catch (error) {
      console.error("Error export excel report:", error);
    }
  };

  normalizeSearchReportVoucher = (rawSearch = {}) => {
    const { staffId, departmentId, ...rest } = rawSearch;
    return {
      ...rest,
      staffId: staffId?.id || null,
      departmentId: departmentId?.id || null,
    };
  };

  resetStore = () => {
    this.listData = null
    this.searchFee = { ...new SearchObject(), fromDate: new Date(), toDate: new Date() }

  }
}